import { assertNever } from "../../amorg-common";
import { ColorSystem } from "../colors/color";

export const ButtonVariants = ["filled", "outlined", "text", "text-white", "destructive", "destructive-text", "light", "clean", "dimmed"] as const;
export type ButtonVariant = typeof ButtonVariants[number];

export const ButtonSizes = ["22px", "32px", "42px", "52px"] as const;
export type ButtonSize = typeof ButtonSizes[number];

export const ButtonFontSizes = ["16px", "18px", "20px", "22px"] as const;
export type ButtonFontSize = typeof ButtonFontSizes[number];

type ButtonStyleConfig = {
    border:string,
    text:string,
    textHover:string,
    textDisabled:string,
    background:string,
    backgroundHover:string,
    backgroundDisabled:string,
}

function getButtonStyleConfig(variant:ButtonVariant, colorSystem:ColorSystem):ButtonStyleConfig
{
    switch(variant)
    {
        case "filled": return colorSystem.button.filled;
        case "outlined": return colorSystem.button.outlined;
        case "text": return colorSystem.button.text;
        case "text-white": return colorSystem.button.textWhite;
        case "destructive": return colorSystem.button.destructive;
        case "destructive-text": return colorSystem.button.destructiveText;
        case "light": return colorSystem.button.light;
        case "clean": return colorSystem.button.clean;
        case "dimmed": return colorSystem.button.dimmed;

        default: assertNever(variant);
    }
}

export const buttonStyling = (colorSystem:ColorSystem) => ({

    getConfig: getButtonStyleConfig,

    handleButtonBackground: (variant: ButtonVariant) => 
        getButtonStyleConfig(variant, colorSystem).background
    ,

     handleButtonHoverBackground: (variant: ButtonVariant) =>
        getButtonStyleConfig(variant, colorSystem).backgroundHover
    ,

    handleButtonColor: (variant: ButtonVariant) => 
        getButtonStyleConfig(variant, colorSystem).text
    ,

    handleButtonHoverColor: (variant: ButtonVariant) => 
        getButtonStyleConfig(variant, colorSystem).textHover
    ,

    handleButtonBackgroundDisabled: (variant: ButtonVariant) => 
        getButtonStyleConfig(variant, colorSystem).backgroundDisabled
    ,

    handleButtonColorDisabled: (variant: ButtonVariant) =>
        getButtonStyleConfig(variant, colorSystem).textDisabled
    ,

    handleButtonBorder: (variant: ButtonVariant) =>
        getButtonStyleConfig(variant, colorSystem).border,
    
});